import Vue from 'vue'
import Router from 'vue-router'

//组件模块
import index from './components/index'
import indexT from './components/index2'
import introduce from './components/introduce'
import detai from './components/detai'
import shoud1 from './components/sd1'
import artList from './components/artList'
import artList1 from './components/artList1'
import tList from './components/tList'
import shoud from './components/sd'
import shoud2 from './components/sd2'
import shoud3 from './components/sd3'
import test from './components/test'
import test1 from './components/testT1'
import test2 from './components/testT2'
import EOfJejUQw1 from './components/EOfJejUQw1'

Vue.use(Router)
export default new Router({
  //base:'haihunhou',
  routes: [
    { path: '/', name: 'index', component: index ,meta: {title: '彩绘地中海'}},
    { path: '/indexT', name: 'indexT', component: indexT,meta: {title: '彩绘地中海'}},
    { path: '/shoud', name: 'shoud', component: shoud,meta: {title: '彩绘地中海'}},
    { path: '/introduce', name: 'introduce', component: introduce ,meta: {title: '彩绘地中海'} },
    { path: '/detai', name: 'detai', component: detai ,meta: {title: '彩绘地中海'} },
    { path: '/shoud1', name: 'shoud1', component: shoud1 ,meta: {title: '彩绘地中海'}},
    { path: '/shoud2', name: 'shoud2', component: shoud2 ,meta: {title: '彩绘地中海'}},
    { path: '/shoud3', name: 'shoud3', component: shoud3 ,meta: {title: '彩绘地中海'}},
    { path: '/artList', name: 'artList', component: artList ,meta: {title: '彩绘地中海-文物列表'} },
    { path: '/artList1', name: 'artList1', component: artList1 ,meta: {title: '彩绘地中海-文物列表'} },
    { path: '/tList', name: 'tList', component: tList ,meta: {title: '彩绘地中海'}},
    { path: '/test', name: 'test', component: test ,meta: {title: '彩绘地中海'}},
    { path: '/test1', name: 'test1', component: test1 ,meta: {title: '彩绘地中海'}},
    { path: '/test2', name: 'test2', component: test2 ,meta: {title: '彩绘地中海'}}
  ],
  scrollBehavior (to, from, savedPosition) {
       if (savedPosition) {
        return savedPosition
       } else {
        return { x: 0, y: 0 }
       }
   }
})
var reg = new RegExp("code=([^&]+)");